import React from 'react';
import { useMessage } from '@messageformat/react';
import { IconPositive } from '@op/opds.opux-icons/indicator';
import { IconComponent } from '@op/opds.opux-icons/misc';
import styles from './FeedbackMessage.module.scss';

interface FeedbackMessageProps {
  hasAnswered: boolean;
  isCorrect: boolean;
  infoText?: string;
}

const FeedbackMessage = ({
  hasAnswered,
  isCorrect,
  infoText,
}: FeedbackMessageProps): React.ReactElement | null => {
  const correctAnswer = useMessage('correct_answer');
  const incorrectAnswer = useMessage('incorrect_answer');
  const tryAgain = useMessage('try_again');

  if (!hasAnswered) {
    return <div aria-live="polite" aria-atomic="true" />;
  }

  const icon = isCorrect ? (
    <IconPositive size="large" color="positive" />
  ) : (
    <IconComponent size="large" color="action" />
  );

  const message = isCorrect ? correctAnswer : tryAgain;
  const a11yMessage = isCorrect
    ? `${correctAnswer}.`
    : `${incorrectAnswer}. ${tryAgain}.`;

  return (
    <div aria-live="polite" aria-atomic="true">
      <div
        className={`${styles.container} ${isCorrect ? styles.correct : styles.incorrect}`}
      >
        <p className={styles.badge} aria-hidden="true">
          {icon}
          {message}
        </p>
        <p className="sr-only">{a11yMessage}</p>
        {infoText && hasAnswered && <p className={styles.info}>{infoText}</p>}
      </div>
    </div>
  );
};

export default FeedbackMessage;
